import { PostProperties } from "../types";
import image from "../img/lostGemDustinZahn.jpg";

const post: PostProperties = {
  id: 30,
  title: "Dustin Zahn - Summer in Minneapollis, Enemy Mix 07 (01.06.2008)",
  content: `Dustin Zahn is one of the renowned Minneapolis-born artists, known for his dynamic approach to underground techno. Zahn has built a reputation for his ability to blend hard-hitting rhythms with atmospheric textures. Over the years, his releases on labels like Drumcode, Horizontal Ground, and Electric Deluxe have earned him a loyal following. This is the 7th installment of the Enemy Mix Series tittled "Summer in Minneapollis", which used to be available on the Enemy Records website some time ago.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/dustin-zahn-minneapolis-studioset-enemy-mix-07-01062008",
  category: "Lost Gem",
  translationsBg: {
    content: `Dustin Zahn е един от известните артисти, родени в Минеаполис, известен с динамичния си подход към ъндърграунд техното. Зан си е изградил репутация заради способността си да съчетава силни ритми с атмосферни текстури. През годините изданията му за лейбъли като Drumcode, Horizontal Ground и Electric Deluxe са му спечелили лоялни последователи. Това е седмата част от серията Enemy Mix, озаглавена „Summer in Minneapollis“, която преди време беше достъпна на уебсайта на Enemy Records.`,
  },
};

export default post;
